import { NodeType } from '@nodeTypeConfig/configTypes';

export const extendsSection = {
  extends: NodeType.SECTION,
  isCollapsible: true,
  onNewNodeDropped: {
    focusOnField: 'title',
  },
} as const;
